import React, { useEffect, useState } from 'react';
import { PlayIcon, PauseIcon, XIcon, Volume2Icon, SkipBackIcon, SkipForwardIcon, MaximizeIcon } from 'lucide-react';
interface MoviePlayerProps {
  onClose: () => void;
}
export const MoviePlayer = ({
  onClose
}: MoviePlayerProps) => {
  const [isPlaying, setIsPlaying] = useState(true);
  const [showControls, setShowControls] = useState(true);
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    // Initial check
    checkIfMobile();
    // Add event listener for window resize
    window.addEventListener('resize', checkIfMobile);
    // Cleanup
    return () => window.removeEventListener('resize', checkIfMobile);
  }, []);
  // Auto-hide controls after 3 seconds of inactivity
  useEffect(() => {
    let timeout: NodeJS.Timeout;
    const resetTimeout = () => {
      if (timeout) clearTimeout(timeout);
      setShowControls(true);
      timeout = setTimeout(() => {
        setShowControls(false);
      }, 3000);
    };
    resetTimeout();
    window.addEventListener('mousemove', resetTimeout);
    window.addEventListener('touchstart', resetTimeout);
    return () => {
      if (timeout) clearTimeout(timeout);
      window.removeEventListener('mousemove', resetTimeout);
      window.removeEventListener('touchstart', resetTimeout);
    };
  }, []);
  return <div className="fixed inset-0 z-50 bg-black" onMouseMove={() => setShowControls(true)} onClick={() => setShowControls(!showControls)} data-id="element-319">
      {/* Video Player */}
      <video className="w-full h-full object-cover" src="https://assets.mixkit.co/videos/preview/mixkit-spinning-around-the-earth-29351-large.mp4" autoPlay loop playsInline data-id="element-320" />
      {/* Controls Overlay */}
      <div className={`absolute inset-0 bg-gradient-to-t from-black via-transparent to-black/40 transition-opacity duration-300 ${showControls ? 'opacity-100' : 'opacity-0'}`} data-id="element-321">
        {/* Top Bar */}
        <div className="absolute top-0 left-0 right-0 p-4 md:p-6 flex justify-between items-center" data-id="element-322">
          <h1 className="text-xl md:text-2xl font-bold" data-id="element-323">The Batman</h1>
          <button onClick={e => {
          e.stopPropagation();
          onClose();
        }} className="p-2 hover:bg-white/10 rounded-full transition-colors" aria-label="Close player" data-id="element-324">
            <XIcon className="w-6 h-6" data-id="element-325" />
          </button>
        </div>
        {/* Center Play/Pause Button */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2" data-id="element-326">
          <button onClick={e => {
          e.stopPropagation();
          setIsPlaying(!isPlaying);
        }} className="p-4 hover:bg-white/10 rounded-full transition-colors" aria-label={isPlaying ? 'Pause' : 'Play'} data-id="element-327">
            {isPlaying ? <PauseIcon className="w-12 h-12" data-id="element-328" /> : <PlayIcon className="w-12 h-12" data-id="element-329" />}
          </button>
        </div>
        {/* Bottom Controls */}
        <div className="absolute bottom-0 left-0 right-0 p-4 md:p-6 space-y-4" data-id="element-330">
          {/* Progress Bar */}
          <div className="w-full h-1 bg-white/30 rounded-full overflow-hidden" data-id="element-331">
            <div className="w-[45%] h-full bg-white rounded-full" data-id="element-332" />
          </div>
          {/* Control Buttons */}
          <div className="flex items-center justify-between" data-id="element-333">
            <div className="flex items-center space-x-2 md:space-x-4" data-id="element-334">
              <button className="p-1 md:p-2 hover:bg-white/10 rounded-full transition-colors" data-id="element-335">
                <SkipBackIcon className="w-4 h-4 md:w-6 md:h-6" data-id="element-336" />
              </button>
              <button onClick={e => {
              e.stopPropagation();
              setIsPlaying(!isPlaying);
            }} className="p-1 md:p-2 hover:bg-white/10 rounded-full transition-colors" data-id="element-337">
                {isPlaying ? <PauseIcon className="w-4 h-4 md:w-6 md:h-6" data-id="element-338" /> : <PlayIcon className="w-4 h-4 md:w-6 md:h-6" data-id="element-339" />}
              </button>
              <button className="p-1 md:p-2 hover:bg-white/10 rounded-full transition-colors" data-id="element-340">
                <SkipForwardIcon className="w-4 h-4 md:w-6 md:h-6" data-id="element-341" />
              </button>
              {!isMobile && <>
                  <div className="flex items-center space-x-2" data-id="element-342">
                    <Volume2Icon className="w-5 h-5" data-id="element-343" />
                    <span className="text-sm" data-id="element-344">100%</span>
                  </div>
                  <div className="flex items-center space-x-2" data-id="element-345">
                    <span className="text-sm" data-id="element-346">1:23:45</span>
                    <span className="text-sm text-gray-400" data-id="element-347">/</span>
                    <span className="text-sm text-gray-400" data-id="element-348">2:35:40</span>
                  </div>
                </>}
            </div>
            {isMobile ? <span className="text-xs" data-id="element-349">1:23:45 / 2:35:40</span> : <button className="p-2 hover:bg-white/10 rounded-full transition-colors" data-id="element-350">
                <MaximizeIcon className="w-6 h-6" data-id="element-351" />
              </button>}
          </div>
        </div>
      </div>
    </div>;
};